import DetailsItem from './DetailsItem';

export default DetailsItem;
